// ── PWA install-button state ──
//
// Owns the deferred `beforeinstallprompt` event and drives visibility of the
// navbar's "Install app" button. Registered at module load from index.js
// (not from a post-auth mount) so the event isn't missed while the user is
// still on the login page — Chrome can fire it before the app layout/navbar
// ever mounts.
//
// Note: iOS Safari and Firefox never fire `beforeinstallprompt` — the button
// simply stays hidden there (no "add to home screen" tutorial in scope).

const BTN_ID = 'pwa-install';

let deferredPrompt = null;
let initialized = false;

function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true;
}

export function refreshInstallButton() {
  const btn = document.getElementById(BTN_ID);
  if (!btn) return; // navbar not mounted yet — state is still tracked, applied on bind
  btn.hidden = !(deferredPrompt && !isStandalone());
}

async function onInstallClick() {
  const p = deferredPrompt;
  if (!p) return;
  // Consume before awaiting — a beforeinstallprompt event can only be used
  // once, so null it out immediately to guard against a double-click firing
  // prompt() twice on the same event.
  deferredPrompt = null;
  refreshInstallButton();
  p.prompt();
  try { await p.userChoice; } catch (_) { /* ignore */ }
}

export function bindInstallButton() {
  const btn = document.getElementById(BTN_ID);
  if (!btn) return;
  btn.addEventListener('click', onInstallClick);
  refreshInstallButton(); // apply any state captured before the navbar mounted
}

export function initPwaInstall() {
  if (initialized) return;
  initialized = true;

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    refreshInstallButton();
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    refreshInstallButton();
  });
}
